// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card_YoMwW {
  width: 100%;
  margin-top: 20px;
  overflow: hidden;
  word-break: break-word;
}
.switchWidth_soI47 {
  margin-right: '-100px';
}
.table__0lwp {
  margin-top: 30px;
}
.formWrapper_jj023 {
  margin-top: 20px;
}
.inputWidth_j5R3l {
  width: 1000px;
}
.expandCard_mhP5W {
  margin-left: 45px;
}
.cardContainer_rq4zQ {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.expandRow_B8Lpe {
  margin-bottom: 10px;
  font-weight: 600;
}
.expandRowValue_sO2MS {
  font-weight: 300;
  margin-left: 5px;
  max-height: 400px;
}
.expandTable_biaap {
  display: block;
  font-weight: 600;
}
.dateWidth_nN_SA {
  position: absolute !important;
  width: 100% !important;
  top: 0px !important;
}
.topdropdown_rYCqb {
  position: absolute;
  margin-right: 20px;
  right: 0;
  width: 120px;
}
.topdropdown2_xFRPz {
  position: absolute;
  margin-right: 150px;
  right: 0;
  width: 120px;
}
.viewIcon_IiQ4b {
  font-size: 24px;
}
.viewInput_Nn7BE {
  margin-top: 8px;
}
.customDropdown_tOhuV {
  max-height: 300px;
}
.dataValue_bt9Db {
  margin-top: 8px;
  font-size: 18px;
  font-weight: 400;
  width: 300px;
  margin-bottom: 10px;
}
.rightDescription_sREY_ {
  margin-bottom: 10px;
}
.usredropdown_Dmq4L {
  position: absolute;
  width: 350px;
  margin-left: 20px;
  height: 60px;
  margin-left: 350px;
  justify-content: center;
  left: 0;
  margin-bottom: 50px;
}
.usredropdown_Dmq4L::-ms-expand {
  width: 30px;
  height: 30px;
}
.usredropdown_Dmq4L option {
  height: 30px;
  margin-bottom: 50px;
}
.dataLabel_IOgFN {
  font-weight: 600;
  margin-top: 20px;
}
.hr_ntKZc {
  position: relative;
  margin-top: 10px;
  width: 660px;
  margin-left: 0;
  align-self: left;
  margin-bottom: 15px;
}
.dataItem_tV6Wq {
  padding: 10px;
  height: 100px;
  width: 100%;
}
.clickableIcon_S4TYP {
  cursor: pointer;
}
.pageContainer_gN9Kh {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.content_f8Pnc {
  flex: 1 1;
}
.copyrightText_jrF6W {
  text-align: center;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 10;
}
.copyrightText_jrF6W a {
  text-decoration: underline;
}
.left_pagination_3dIQQ {
  text-align: left;
  flex: 1 1;
  left: 0;
  margin-right: -10px;
}
.custom_pagination_is_rw {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  left: 0px;
}
.AddButtonSize_mQ2TT {
  margin-left: 0px;
}
.RegisterClientButton_SZnpE {
  margin-right: 15px;
}
.AddBtn_dzFuf {
  position: absolute;
  right: 0;
  margin: 24px;
  top: 0px;
}
.compliance_container_Q6_SS {
  width: 1000px;
}
.boldLabel_h76sS {
  margin-left: 5px;
  font-weight: bold;
}
.corporateOfficercollaps_W6Bd7 {
  position: static;
  width: 100%;
}
.InputNumber_mBSzH {
  width: 100%;
}
.SupplierInfoList_Ml9b_ {
  margin: 5px;
}
.SupplierInfoSwitch_IMzgi {
  margin-right: 20px;
}
.supplierInfoCollapseWidth_L7FFg {
  width: 1000px;
  margin-right: 20px;
}
.repeatWidth_Hs07O {
  width: '30%';
}
.recureWidth_ItCwK {
  width: '70%';
  margin-left: 2px;
}
.officerButtonMargin_QCXoD {
  margin-top: 15px;
  margin-bottom: 5px;
}
.bussinessToggle_rSv8V {
  display: inline-flex;
  align-items: center;
}
.bussinesToggleA_vyvbX {
  display: inline-flex;
  align-items: center;
  margin-left: 10px;
}
.bussinesToggleB_M_Yab {
  margin-left: 18px;
}
.commonStyles_tkCX8.bussinessToggleContainer_bp5H8 {
  display: flex;
  justify-content: space-between;
}
.homeListBasic_EZSLs {
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.corporateInitial_q1OEF {
  flex: 1 1;
  width: 500px;
}
.corporateInform_STXQ1 {
  display: flex;
  width: 100%;
}
.corporateBasicDetails_TAiAK {
  flex: 1 1;
}
.corpList_JtwlM {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.flexDirectionRow_Nwdn2 {
  display: flex;
  flex-direction: row;
}
.requireIcon_gnf9C {
  color: red;
}
.marginBottom45_pfEgh {
  margin-bottom: 45px;
}
.marginBottom100_tRW6B {
  margin-bottom: 80px;
  margin-top: 20px;
}
.marginBottom10_Oqr34 {
  margin-bottom: 10px;
}
.margintRight100_Dg1a6 {
  margin-right: 100px;
}
.colorGray_pcd4p {
  color: gray;
}
.margingTop10_aMejb {
  margin-top: 10px;
}
.width100_F9IOI {
  width: 100%;
}
.usermangementimage_uCVKE {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.requireIcon_gnf9C {
  color: red;
}
.blueOutline_nSzwH {
  background-color: 2px solid blue;
}
.historyButton_RvTx2 {
  width: 200px;
  height: 75px !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  margin-bottom: 30px;
}
.buttontext_QGILz {
  font-size: 30px;
  font-weight: 700;
  margin-right: 'auto';
}
.main_V7uOw {
  display: flex;
  flex-direction: column;
  min-height: 80vh;
}
.contener_X8TCk {
  display: flex;
  align-items: center;
  height: auto;
  width: 350px;
  background-color: #f7f2e8;
  padding: 10px;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 20px;
}
.imagemain_ZHXS4 {
  flex: 1 1;
}
.image_V6GZc {
  width: 60px;
  height: 80px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.chattextMain_wsZWp {
  flex: 2 1;
  padding-left: 5px;
}
.chatheding_BUXLe {
  font-size: 18px;
  font-weight: 700;
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
.chatsubheading_EGftQ {
  color: #7d8895;
  font-size: 10px;
}
.formspace_XtGl4 {
  margin-top: auto;
}
.buttonimageIcon_LSXoq {
  transform: rotate(-45deg);
}
.scrollContainer_Hygcy {
  max-height: 400px;
  overflow-y: auto;
}
.defaultUI_nEBaK {
  width: auto;
}
.imagewidth_HDS2S {
  width: 100%;
  margin-top: 20px;
  object-fit: cover;
}
.margin_Top20_gOhiN {
  margin-top: 50px;
  margin-bottom: 30px;
}
.overlay_mgcsC {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
`, "",{"version":3,"sources":["webpack://./src/Utils/Common.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;AACJ;AAEA;EACI,sBAAA;AAAJ;AAGA;EACI,gBAAA;AADJ;AAIA;EACI,gBAAA;AAFJ;AAKA;EACI,aAAA;AAHJ;AAMA;EACI,iBAAA;AAJJ;AAOA;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AALJ;AAQA;EACI,mBAAA;EACA,gBAAA;AANJ;AASA;EACI,gBAAA;EACA,gBAAA;EACA,iBAAA;AAPJ;AAUA;EACI,cAAA;EACA,gBAAA;AARJ;AAWA;EACI,6BAAA;EACA,sBAAA;EACA,mBAAA;AATJ;AAYA;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;AAVJ;AAaA;EACI,kBAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAXJ;AAcA;EACI,eAAA;AAZJ;AAeA;EACI,eAAA;AAbJ;AAgBA;EACI,iBAAA;AAdJ;AAiBA;EACI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAfJ;AAkBA;EACI,mBAAA;AAhBJ;AAmBA;EACI,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,OAAA;EACA,mBAAA;AAjBJ;AAoBA;EACI,WAAA;EACA,YAAA;AAlBJ;AAqBA;EACI,YAAA;EACA,mBAAA;AAnBJ;AAsBA;EACI,gBAAA;EACA,gBAAA;AApBJ;AAuBA;EACI,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AArBJ;AAwBA;EACI,aAAA;EACA,aAAA;EACA,WAAA;AAtBJ;AAyBA;EACI,eAAA;AAvBJ;AA0BA;EACI,aAAA;EACA,sBAAA;EACA,iBAAA;AAxBJ;AA2BA;EACI,SAAA;AAzBJ;AA4BA;EACI,kBAAA;EAGA,WAAA;EAEA,SAAA;EACA,OAAA;EACA,WAAA;AA7BJ;AAgCA;EACI,0BAAA;AA9BJ;AAiCA;EACI,gBAAA;EACA,SAAA;EACA,OAAA;EACA,mBAAA;AA/BJ;AAkCA;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAhCJ;AAmCA;EACI,gBAAA;AAjCJ;AAoCA;EACI,kBAAA;AAlCJ;AAoCA;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,QAAA;AAlCJ;AAqCA;EACI,aAAA;AAnCJ;AAqCA;EACI,gBAAA;EACA,iBAAA;AAnCJ;AAsCA;EACI,gBAAA;EACA,WAAA;AApCJ;AAuCA;EACI,WAAA;AArCJ;AAuCA;EACI,WAAA;AArCJ;AAwCA;EACI,kBAAA;AAtCJ;AAyCA;EACI,aAAA;EACA,kBAAA;AAvCJ;AA0CA;EACI,YAAA;AAxCJ;AA2CA;EACI,YAAA;EACA,gBAAA;AAzCJ;AA2CA;EACI,gBAAA;EACA,kBAAA;AAzCJ;AA4CA;EACI,oBAAA;EACA,mBAAA;AA1CJ;AA6CA;EACI,oBAAA;EACA,mBAAA;EACA,iBAAA;AA3CJ;AA8CA;EACI,iBAAA;AA5CJ;AA+CA;EACI,aAAA;EACA,8BAAA;AA7CJ;AAgDA;EACI,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AA9CJ;AAiDA;EACI,SAAA;EACA,YAAA;AA/CJ;AAkDA;EACI,aAAA;EACA,WAAA;AAhDJ;AAmDA;EACI,SAAA;AAjDJ;AAoDA;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AAlDJ;AAqDA;EACI,aAAA;EACA,mBAAA;AAnDJ;AAsDA;EACI,UAAA;AApDJ;AAuDA;EACI,mBAAA;AArDJ;AAwDA;EACI,mBAAA;EACA,gBAAA;AAtDJ;AAyDA;EACI,mBAAA;AAvDJ;AA0DA;EACI,mBAAA;AAxDJ;AA2DA;EACI,WAAA;AAzDJ;AA4DA;EACI,gBAAA;AA1DJ;AA6DA;EACI,WAAA;AA3DJ;AA6DA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AA3DJ;AA6DA;EACI,UAAA;AA3DJ;AA6DA;EACI,gCAAA;AA3DJ;AA6DA;EACI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA3DJ;AA6DA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;AA3DJ;AA6DA;EACI,aAAA;EACA,sBAAA;EACA,gBAAA;AA3DJ;AA6DA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,wCAAA;EACA,gBAAA;AA3DJ;AA6DA;EACI,SAAA;AA3DJ;AA6DA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;AA3DJ;AA6DA;EACI,SAAA;EACA,iBAAA;AA3DJ;AA6DA;EACI,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,iCAAA;EACA,oCAAA;AA3DJ;AA6DA;EACI,cAAA;EACA,eAAA;AA3DJ;AA6DA;EACI,gBAAA;AA3DJ;AA6DA;EACI,yBAAA;AA3DJ;AA8DA;EACI,iBAAA;EACA,gBAAA;AA5DJ;AA8DA;EACI,WAAA;AA5DJ;AA8DA;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;AA5DJ;AA+DA;EACI,gBAAA;EACA,mBAAA;AA7DJ;AA+DA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AA7DJ","sourcesContent":[".card {\n    width: 100%;\n    margin-top: 20px;\n    overflow: hidden;\n    word-break: break-word;\n}\n\n.switchWidth {\n    margin-right: '-100px';\n}\n\n.table {\n    margin-top: 30px;\n}\n\n.formWrapper {\n    margin-top: 20px;\n}\n\n.inputWidth {\n    width: 1000px;\n}\n\n.expandCard {\n    margin-left: 45px;\n}\n\n.cardContainer {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.expandRow {\n    margin-bottom: 10px;\n    font-weight: 600;\n}\n\n.expandRowValue {\n    font-weight: 300;\n    margin-left: 5px;\n    max-height: 400px;\n}\n\n.expandTable {\n    display: block;\n    font-weight: 600;\n}\n\n.dateWidth {\n    position: absolute !important;\n    width: 100% !important;\n    top: 0px !important;\n}\n\n.topdropdown {\n    position: absolute;\n    margin-right: 20px;\n    right: 0;\n    width: 120px;\n}\n\n.topdropdown2 {\n    position: absolute;\n    margin-right: 150px;\n    right: 0;\n    width: 120px;\n}\n\n.viewIcon {\n    font-size: 24px;\n}\n\n.viewInput {\n    margin-top: 8px;\n}\n\n.customDropdown {\n    max-height: 300px;\n}\n\n.dataValue {\n    margin-top: 8px;\n    font-size: 18px;\n    font-weight: 400;\n    width: 300px;\n    margin-bottom: 10px;\n}\n\n.rightDescription {\n    margin-bottom: 10px;\n}\n\n.usredropdown {\n    position: absolute;\n    width: 350px;\n    margin-left: 20px;\n    height: 60px;\n    margin-left: 350px;\n    justify-content: center;\n    left: 0;\n    margin-bottom: 50px;\n}\n\n.usredropdown::-ms-expand {\n    width: 30px;\n    height: 30px;\n}\n\n.usredropdown option {\n    height: 30px;\n    margin-bottom: 50px;\n}\n\n.dataLabel {\n    font-weight: 600;\n    margin-top: 20px;\n}\n\n.hr {\n    position: relative;\n    margin-top: 10px;\n    width: 660px;\n    margin-left: 0;\n    align-self: left;\n    margin-bottom: 15px;\n}\n\n.dataItem {\n    padding: 10px;\n    height: 100px;\n    width: 100%;\n}\n\n.clickableIcon {\n    cursor: pointer;\n}\n\n.pageContainer {\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n}\n\n.content {\n    flex: 1;\n}\n\n.copyrightText {\n    text-align: center;\n    // padding: 10px 0;\n    // background-color: #f8f9fa;\n    width: 100%;\n    // position: fixed;\n    bottom: 0;\n    left: 0;\n    z-index: 10;\n}\n\n.copyrightText a {\n    text-decoration: underline;\n}\n\n.left_pagination {\n    text-align: left;\n    flex: 1;\n    left: 0;\n    margin-right: -10px;\n}\n\n.custom_pagination {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    left: 0px;\n}\n\n.AddButtonSize {\n    margin-left: 0px;\n}\n\n.RegisterClientButton {\n    margin-right: 15px;\n}\n.AddBtn {\n    position: absolute;\n    right: 0;\n    margin: 24px;\n    top: 0px;\n}\n\n.compliance_container {\n    width: 1000px;\n}\n.boldLabel {\n    margin-left: 5px;\n    font-weight: bold;\n}\n\n.corporateOfficercollaps {\n    position: static;\n    width: 100%;\n}\n\n.InputNumber {\n    width: 100%;\n}\n.SupplierInfoList {\n    margin: 5px;\n}\n\n.SupplierInfoSwitch {\n    margin-right: 20px;\n}\n\n.supplierInfoCollapseWidth {\n    width: 1000px;\n    margin-right: 20px;\n}\n\n.repeatWidth {\n    width: '30%';\n}\n\n.recureWidth {\n    width: '70%';\n    margin-left: 2px;\n}\n.officerButtonMargin {\n    margin-top: 15px;\n    margin-bottom: 5px;\n}\n\n.bussinessToggle {\n    display: inline-flex;\n    align-items: center;\n}\n\n.bussinesToggleA {\n    display: inline-flex;\n    align-items: center;\n    margin-left: 10px;\n}\n\n.bussinesToggleB {\n    margin-left: 18px;\n}\n\n.commonStyles.bussinessToggleContainer {\n    display: flex;\n    justify-content: space-between;\n}\n\n.homeListBasic {\n    margin-top: 15px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.corporateInitial {\n    flex: 1;\n    width: 500px;\n}\n\n.corporateInform {\n    display: flex;\n    width: 100%;\n}\n\n.corporateBasicDetails {\n    flex: 1;\n}\n\n.corpList {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n\n.flexDirectionRow {\n    display: flex;\n    flex-direction: row;\n}\n\n.requireIcon {\n    color: red;\n}\n\n.marginBottom45 {\n    margin-bottom: 45px;\n}\n\n.marginBottom100 {\n    margin-bottom: 80px;\n    margin-top: 20px;\n}\n\n.marginBottom10 {\n    margin-bottom: 10px;\n}\n\n.margintRight100 {\n    margin-right: 100px;\n}\n\n.colorGray {\n    color: gray;\n}\n\n.margingTop10 {\n    margin-top: 10px;\n}\n\n.width100 {\n    width: 100%;\n}\n.usermangementimage {\n    width: 50px;\n    height: 50px;\n    object-fit: cover;\n}\n.requireIcon {\n    color: red;\n}\n.blueOutline {\n    background-color: 2px solid blue;\n}\n.historyButton {\n    width: 200px;\n    height: 75px !important;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    margin-bottom: 30px;\n}\n.buttontext {\n    font-size: 30px;\n    font-weight: 700;\n    margin-right: 'auto';\n}\n.main {\n    display: flex;\n    flex-direction: column;\n    min-height: 80vh;\n}\n.contener {\n    display: flex;\n    align-items: center;\n    height: auto;\n    width: 350px;\n    background-color: #f7f2e8;\n    padding: 10px;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    margin-top: 20px;\n}\n.imagemain {\n    flex: 1;\n}\n.image {\n    width: 60px;\n    height: 80px;\n    object-fit: cover;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n.chattextMain {\n    flex: 2;\n    padding-left: 5px;\n}\n.chatheding {\n    font-size: 18px;\n    font-weight: 700;\n    white-space: normal !important;\n    word-break: break-word !important;\n    overflow-wrap: break-word !important;\n}\n.chatsubheading {\n    color: #7d8895;\n    font-size: 10px;\n}\n.formspace {\n    margin-top: auto;\n}\n.buttonimageIcon {\n    transform: rotate(-45deg);\n}\n\n.scrollContainer {\n    max-height: 400px;\n    overflow-y: auto;\n}\n.defaultUI {\n    width: auto;\n}\n.imagewidth {\n    width: 100%;\n    margin-top: 20px;\n    object-fit: cover;\n}\n\n.margin_Top20 {\n    margin-top: 50px;\n    margin-bottom: 30px;\n}\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.7);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n@primary-color: #2FB153;@link-color: #1DA57A;@border-radius-base: 2px;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card_YoMwW`,
	"switchWidth": `switchWidth_soI47`,
	"table": `table__0lwp`,
	"formWrapper": `formWrapper_jj023`,
	"inputWidth": `inputWidth_j5R3l`,
	"expandCard": `expandCard_mhP5W`,
	"cardContainer": `cardContainer_rq4zQ`,
	"expandRow": `expandRow_B8Lpe`,
	"expandRowValue": `expandRowValue_sO2MS`,
	"expandTable": `expandTable_biaap`,
	"dateWidth": `dateWidth_nN_SA`,
	"topdropdown": `topdropdown_rYCqb`,
	"topdropdown2": `topdropdown2_xFRPz`,
	"viewIcon": `viewIcon_IiQ4b`,
	"viewInput": `viewInput_Nn7BE`,
	"customDropdown": `customDropdown_tOhuV`,
	"dataValue": `dataValue_bt9Db`,
	"rightDescription": `rightDescription_sREY_`,
	"usredropdown": `usredropdown_Dmq4L`,
	"dataLabel": `dataLabel_IOgFN`,
	"hr": `hr_ntKZc`,
	"dataItem": `dataItem_tV6Wq`,
	"clickableIcon": `clickableIcon_S4TYP`,
	"pageContainer": `pageContainer_gN9Kh`,
	"content": `content_f8Pnc`,
	"copyrightText": `copyrightText_jrF6W`,
	"left_pagination": `left_pagination_3dIQQ`,
	"custom_pagination": `custom_pagination_is_rw`,
	"AddButtonSize": `AddButtonSize_mQ2TT`,
	"RegisterClientButton": `RegisterClientButton_SZnpE`,
	"AddBtn": `AddBtn_dzFuf`,
	"compliance_container": `compliance_container_Q6_SS`,
	"boldLabel": `boldLabel_h76sS`,
	"corporateOfficercollaps": `corporateOfficercollaps_W6Bd7`,
	"InputNumber": `InputNumber_mBSzH`,
	"SupplierInfoList": `SupplierInfoList_Ml9b_`,
	"SupplierInfoSwitch": `SupplierInfoSwitch_IMzgi`,
	"supplierInfoCollapseWidth": `supplierInfoCollapseWidth_L7FFg`,
	"repeatWidth": `repeatWidth_Hs07O`,
	"recureWidth": `recureWidth_ItCwK`,
	"officerButtonMargin": `officerButtonMargin_QCXoD`,
	"bussinessToggle": `bussinessToggle_rSv8V`,
	"bussinesToggleA": `bussinesToggleA_vyvbX`,
	"bussinesToggleB": `bussinesToggleB_M_Yab`,
	"commonStyles": `commonStyles_tkCX8`,
	"bussinessToggleContainer": `bussinessToggleContainer_bp5H8`,
	"homeListBasic": `homeListBasic_EZSLs`,
	"corporateInitial": `corporateInitial_q1OEF`,
	"corporateInform": `corporateInform_STXQ1`,
	"corporateBasicDetails": `corporateBasicDetails_TAiAK`,
	"corpList": `corpList_JtwlM`,
	"flexDirectionRow": `flexDirectionRow_Nwdn2`,
	"requireIcon": `requireIcon_gnf9C`,
	"marginBottom45": `marginBottom45_pfEgh`,
	"marginBottom100": `marginBottom100_tRW6B`,
	"marginBottom10": `marginBottom10_Oqr34`,
	"margintRight100": `margintRight100_Dg1a6`,
	"colorGray": `colorGray_pcd4p`,
	"margingTop10": `margingTop10_aMejb`,
	"width100": `width100_F9IOI`,
	"usermangementimage": `usermangementimage_uCVKE`,
	"blueOutline": `blueOutline_nSzwH`,
	"historyButton": `historyButton_RvTx2`,
	"buttontext": `buttontext_QGILz`,
	"main": `main_V7uOw`,
	"contener": `contener_X8TCk`,
	"imagemain": `imagemain_ZHXS4`,
	"image": `image_V6GZc`,
	"chattextMain": `chattextMain_wsZWp`,
	"chatheding": `chatheding_BUXLe`,
	"chatsubheading": `chatsubheading_EGftQ`,
	"formspace": `formspace_XtGl4`,
	"buttonimageIcon": `buttonimageIcon_LSXoq`,
	"scrollContainer": `scrollContainer_Hygcy`,
	"defaultUI": `defaultUI_nEBaK`,
	"imagewidth": `imagewidth_HDS2S`,
	"margin_Top20": `margin_Top20_gOhiN`,
	"overlay": `overlay_mgcsC`
};
export default ___CSS_LOADER_EXPORT___;
